import {tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'
/**
 * @implements UseCase
 */
export default class GetUserFavoritesUseCase extends UseCase {
  constructor({getUserFavoritesService}) {
    super()
    this._getUserFavoritesService = getUserFavoritesService
  }

  /**
   * @return {Promise<Object, Error>}
   */
  @tracer({metric: 'GetUserFavoritesUseCase#execute'})
  async execute({search} = {}) {
    const [getUserFavoritesError, getUserFavoritesResponse] = await this._getUserFavoritesService.execute({
      search
    })

    if (getUserFavoritesError) return Promise.reject(getUserFavoritesError)
    return getUserFavoritesResponse
  }
}
